import { render, staticRenderFns } from "./studentOnApply.vue?vue&type=template&id=20cbf73f&scoped=true&"
import script from "./studentOnApply.vue?vue&type=script&lang=js&"
export * from "./studentOnApply.vue?vue&type=script&lang=js&"
import style0 from "./studentOnApply.vue?vue&type=style&index=0&id=20cbf73f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbf73f",
  null
  
)

export default component.exports